export const SIDEBAR_WIDTH = 430;
export const DEFAULT_QUERY_LIMIT = 50;
export const DEFAULT_MIN_ZOOM = 10;
export const DEFAULT_MAP_STYLE = "grayscale_light";
export const MAX_ZOOM_FOR_COLLECTION_OUTLINE = 6;

export const CQL_PROP_IDX = 0;
export const CQL_VALS_IDX = 1;
